import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {

    constructor(private http: HttpClient) {
    }

    upload(url, file): Observable<any> {
        var language = localStorage.getItem('language') || 'zh';
        const formData = new FormData();
        formData.append('file', file, file.name);
        return this.http.post(url, formData, {
            headers: {
                'Current-Language': language,
            }
        });
    }
}
